export const DISMISS_TIME_PICKER_PROMPT = 'dismiss-time-picker-prompt';
export const DISMISS_TIME_PICKER_PROMPT_COOKIE_NAME = 'pw-time-picker-prompt-dismissed';
const dismissTimePickerPrompt = () => ({ type: DISMISS_TIME_PICKER_PROMPT });
export default dismissTimePickerPrompt;
